import { Injectable } from '@angular/core';
import { InicioPage } from '../models/inicio-page';
import { HttpClient } from '@angular/common/http';
import { PageService } from './page.service';

@Injectable({
  providedIn: 'root'
})
export class MainContentService extends PageService<InicioPage> {

  constructor(http: HttpClient) {
    super(http);
  }
}
